/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
} from 'react';

import './animation011.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation011Item {
  icon: string;
  text: string;
  title?: string;
  tip?: string;
}

interface IAnimation011Props {
  items: IAnimation011Item[];
  className?: string | null;
  onCompleted: () => void;
}

const Animation011: FunctionComponent<IAnimation011Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation011 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <>
      <div ref={crrRef} className={`animation011 component ${className}`}>
        <img
          className="click-point"
          onClick={() => clickToPlay()}
          style={{
            display: play <= 1 ? 'block' : 'none',
          }}
          src={ImgPoint}
          alt=""
        />
        <div className="animation011-content" onClick={() => clickToPlay()}>
          {items.map((itm: IAnimation011Item, idx: number) => (
            <div
              key={idx}
              className={`animation011-item animation r${idx + 1} ${
                play >= idx + 1 ? 'fade-in' : ''
              }`}
              style={{ paddingLeft: idx * 100 }}
            >
              <div className="animation011-icon">
                <img src={getImg(itm.icon)} alt="" />
              </div>
              <div className="animation011-body">
                <div className="animation011-title">{itm.title}</div>
                <div
                  className="animation011-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Animation011;
